module.exports = __webpack_public_path__ + "static/media/04A.f80af0cc.png";